
































import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'Dropdown',
  props: {
    fullWidth: {
      type: Boolean,
      default: false,
    },
    fitHeight: {
      type: Boolean,
      default: true,
    },
    toggleWithIndicatorClick: {
      type: Boolean,
      default: true,
    },
    closeWithListClick: {
      type: Boolean,
      default: true,
    },
    focusWithinList: {
      type: Boolean,
      default: false,
    },
    focusTarget: HTMLElement,
    tabindex: {
      type: Number,
      default: 0,
    },
    listPosition: {
      type: String,
      default: 'left' as 'left'|'right',
    },
    allowBubbling: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    open() {
      if (this.isOpen) { return; }

      this.isOpen = true;

      if (this.focusWithinList) {
        this.$nextTick(() => {
          this.focusTarget.focus();
        });
      } else {
        (this.$el as HTMLElement).focus();
      }
    },
    close() {
      if (!this.isOpen) { return; }

      this.isOpen = false;

      /*if (this.focusWithinList) {
        this.$nextTick(() => {
          this.focusTarget.blur();
        });
      } else {
        (this.$el as HTMLElement).blur();
      }
      */
    },
    toggle() {
      if (!this.toggleWithIndicatorClick) {
        this.open();
      } else {
        this.isOpen ? this.close() : this.open();
      }
    },
    handleListClick() {
      if (this.closeWithListClick) {
        this.close();
      }
    },
    handleClickBubbling(e: Event) {
      if(!this.allowBubbling) { e.stopPropagation(); }
    },
    freezeWhenDisabled(e: Event) {
      if (this.disabled) {
        e.preventDefault();
        e.stopPropagation();

        e.stopImmediatePropagation();
      }
    },
    openIfClosed() {
      if (!this.isOpen) {
        this.open();
      }
    },
    handleEnter() {
      if (this.isOpen) {
        this.$emit('pointerSelect');
        this.close();
      } else {
        this.open();
      }
    },
  },
});
